export default "__VITE_ASSET__28553445__"